import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { LinearProgressBar } from "../../shared";

import {getDefaultTabName} from "../../services/FunctionServices";

export default function CommonFormatComponent(props) {
  const history = useHistory();
  //;
  const { row, type, sampleStatusDetails,subValue,subData } = props;
  //console.log("row",row);
  let linearData=[];
  let max=0;
  if(row.typeOfCase)
  {
    row.typeOfCase.forEach((item)=>{
      max=item.value > max ? item.value:max;
    });
    row.typeOfCase.forEach((item)=>{
      let data={...item};
      data.perValue=(item.value>0?(item.value/(max)) * 100:0);
      linearData.push(data);
    });
}
//console.log(max,"max");
  //console.log(linearData,"test...row")
  const useStyles = makeStyles((theme) => ({
    mainBox: {
      height: "300px"
    },
    roundBox: {
      borderRadius: "50%",
      border: "6px solid #1a1a31",
      height: "130px",
      width: "130px",
      textAlign: "center",
      minWidth: "130px"
       
    },
  }));

  function onReportDetails(data, type) {
    let subType = getDefaultTabName()[0];
    if(type == "SampleStatus"){
      history.push({
        pathname: "/dashboard/sample-status",
        data: data,
        type:type,
        subType: subType
      });

    } else {
      history.push({
        pathname: "/dashboard/reports",
        data: data,
        type:type,
        subType: subType
      });
    }
  }
  const classes = useStyles();
  const [comprender,setcomprender] = React.useState(false)
  const subvaluesdata = () => {
    //
    
   if(subValue=="Fuel"){
     return "* Data displayed for last 90 days based on date sampled"
    //setstatusDisplay('* Data displayed for last 90 days based on date sampled')
   }
   else if(subValue=="Lube"){
     return "* Data displayed for last 180 days based on date sampled"
    //setstatusDisplay('* Data displayed for last 180 days based on date sampled')
  }
  else if(subValue=="Tot"){
    return "* Data displayed for last 730 days based on date sampled"
    //setstatusDisplay('* Data displayed for last 730 days based on date sampled')
  }


  };
  const subdata = (value) => {
    //
    if(value=="Fuel"){
      return "* Data displayed for last 90 days based on date Reported"
    }
    else if(value=="Lube"){
     return "* Data displayed for last 180 days based on date Reported"
   }
   else if(value=="Tot"){
     return "* Data displayed for last 730 days based on date Reported"
   }
  }
  return (
    <div>
      <Box
        component="main"
        bgcolor="#fff"
        borderRadius={4}
        boxShadow={4}
        p={2}
        className={classes.mainBox}
        display="flex"
        onClick={() => {
          onReportDetails(sampleStatusDetails, type);
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Box component="h4" className="dashboard-sub-title" pb={0} fontSize={16} m={0}>
              <Box component="div" display="flex" alignItems="center">
              <Grid container>
                <Grid item xs={12} sm={12} md={6}> 
                <Box component="span" pr={0.5} pt={0.5}>
                  {type=="ReportStatus"? <img src="assets/svg/Reports1.png" /> : <img src="assets/svg/flask.svg" />}
                </Box>
                <Box component="span" className="titlecopy1" > {row.title}  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} className="text-right"> 
                <Box component="span" className="thidays"> {type=='SampleStatus'?subvaluesdata(subValue):subdata(subData) }</Box>
                </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" py={2}>
              <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={5} >
                  <Box
                    component="div"
                    display="flex"
                    pr={2}
                    justifyContent="center"
                  >
                    <Box
                      component="div"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.roundBox}
                    >
                      <Box component="div" className="dash-left-cir">
                        <Box
                          component="h2"
                  
                        >
                          {row.caseCount}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {row.text1} {row.text2}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={7} >
                  {Object.keys(row).length
                    ?   linearData.map((item) => (
                        <Box component="div" key={item.title} pb={1.5} pt={0.8}>
                          <LinearProgressBar
                            colors={item.color}
                            value={item.perValue}
                            numbers={item.value}
                          />
                        </Box>
                      ))
                    : ""}
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" display="flex" alignItems="center">
              {Object.keys(row).length
                ? row.typeOfCase.map((item) => (
                  
                  <Box className="dashboardkey"
                      key={item.title}
                     
                      component="div"
                      pr={2}
                    >
                      <svg height="10" width="10">
                        <circle cx="5" cy="5" r="4" fill={item.color} />
                      </svg>
                      <Box component="span" pl={1}>
                        {item.title}
                      </Box>
                    </Box>
                   
                  ))
                : ""}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
